export const PERSON_NAME_DIGITS_MESSAGE =
  'El nombre y el apellido no pueden contener números.';

export const sanitizePersonNameInput = (value) => String(value ?? '').replace(/\d/g, '');

export const personNameHasDigits = (value) => /\d/.test(String(value ?? ''));

export const getPersonNameError = (nombre, apellido = '') => {
  if (personNameHasDigits(nombre) || personNameHasDigits(apellido)) {
    return PERSON_NAME_DIGITS_MESSAGE;
  }
  return '';
};
